import analytics from '../api/analytics'

const notification = {
  /**
   * Cria um toast de notification
   * @param {Object} notifyObject Data for notification. Contains: type, payload: { title, text and action }
   * @param {Function=} timeoutcb
   * @example
   * notify({ type: <String>,
   *    payload: {
   *      title: <string>,
   *      text: <string>,
   *      action: function
   *    }
   *  })
   */
  notify (notifyObject, timeoutcb = null) {
    if (notifyObject.message) {
      let event = document.createEvent('CustomEvent')
      event.initCustomEvent('custom-notification', true, true, notifyObject)
      document.dispatchEvent(event)
      analytics.pushAnalyticsEvent('error-validation', {'msg-error': notifyObject.message})
    }
  }
}

export default notification.notify
export { notification }
